import { Badge, Box, Button, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, Tab, Table, TableBody, TableContainer, TableHead, Tabs, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import { makeStyles } from "tss-react/mui";
import ErrorHandler from "../../lib/errorHandler";
import StyledTableRow from "../../Component/Common/StyledTableRow";
import StyledTableCell from "../../Component/Common/StyledTableCell";
import { POTypeOptions, Title, useCommonStyles } from "../../utils";
import usePageLoader from "../../Redux/hooks/usePageLoader";
import useSnackBar from "../../Redux/hooks/useSnackBar";
import IconBackground from "../../Component/Common/IconBackground";
import NoDataFound from "../../Component/Common/NoDataFound";
import CommonPagination from "../../Component/Common/CommonPagination";
import AddUpdateCustomer from "../../Component/Invoice/AddUpdateCustomer";
import AddUpdateInvoice from "../../Component/Invoice/AddUpdateInvoice";
import { getInvoiceById, getInvoices } from "../../Redux/Actions/Invoice";
import { standardDateFormat } from "../../lib/standardDateFormat";
import { useAppSelector } from "../../Redux/app/hooks";
import CustomDrawer from "../../Component/Common/CustomDrawer";
import { deleteCustomer, getCustomerById, getCustomers } from "../../Redux/Actions/Customer";
import StatusButton from "../../Component/Common/StatusButton";
import ViewCustomer from "../../Component/Invoice/ViewCustomer";
import { useConfirm } from "material-ui-confirm";
import CommonSearchField from "../../Component/Common/CommonSearchField";

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            border: "1px solid",
            borderColor: "#00000033",
            backgroundColor: "transparent",
            minWidth: "40px",
            minHeight: "40px",
            borderRadius: "10px",
            padding: "10px 14px",
            fontFamily: "Satoshi-Light",
            color: "#131313"
        },
        "& .Mui-selected": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            fontFamily: "Satoshi-Bold",
            backgroundColor: theme.palette.bgWhite.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        }
    },
}));

const invoiceCategory = [
    { name: "Customer List", value: 1 },
    { name: "Invoice List", value: 2 },
];

const Invoice = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Customer List", value: 1 },);
    const [page, setPage] = useState(1);
    const [listData, setListData] = useState({});

    const [isOpenAddUpdateCustomer, setIsOpenAddUpdateCustomer] = useState(false);
    const [isOpenViewCustomer, setIsOpenViewCustomer] = useState(false);
    const [customerData, setCustomerData] = useState({});
    const [selectedCustomerData, setSelectedCustomerData] = useState({});

    const [isOpenAddUpdateInvoice, setIsOpenAddUpdateInvoice] = useState(false);
    const [isOpenViewInvoice, setIsOpenViewInvoice] = useState(false);
    const [selectedInvoiceData, setSelectedInvoiceData] = useState({});
    const [purchaseOrderListData, setPurchaseOrderListData] = useState([]);
    const [invoiceData, setInvoiceData] = useState({ currency: { name: "INR", symbol: "₹" } });
    const [searchValue, setSearchValue] = useState('');

    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);

    const initialFilterState = {
        status: "",
        invoice_type: ''
    };

    const [filterData, setFilterData] = useState(initialFilterState)
    const [isApllyFilter, setIsApplyFilter] = useState(1);
    const filterDataCount = (filterData?.rawMaterial?.length > 0 ? filterData?.rawMaterial?.length : 0) + (filterData?.status?.trim() ? 1 : 0)

    // =============== Handler ===============
    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    let PerPage = 10
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    const handleinvoice_typeChange = (id) => {
        setFilterData((prev) => ({
            ...prev,
            invoice_type: prev.invoice_type === id ? "" : id // Toggle selection
        }));
    };

    const openAddUpdate = () => {
        if (activeTab?.value == 1) {
            setIsOpenAddUpdateCustomer(true)
        } else {
            setIsOpenAddUpdateInvoice(true)
        }
    }
    // ============= get Inventories List API =============
    const _getListData = async (p) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
        }
        if (activeTab?.value == 1) {
            body.status = isApllyFilter ? (filterData?.status?.trim() ? filterData?.status : null) : null;
        }
        if (activeTab?.value == 2) {
            body.invoice_type = isApllyFilter ? (filterData?.invoice_type?.trim() ? +filterData?.invoice_type : null) : null;
        }
        const fn = activeTab?.value == 2 ? getInvoices : getCustomers
        response = await dispatch(fn(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getInvoiceById = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getInvoiceById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                let res = response?.payload?.data
                setIsOpenViewInvoice(true)
                setSelectedInvoiceData(res)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= Get By Id Inventory Field API =============
    const _getCustomerById = async (id, isEdit) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getCustomerById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                const res = response?.payload?.data?.response;
                setSelectedCustomerData(response?.payload?.data?.response)
                if (isEdit) {
                    setIsOpenAddUpdateCustomer(true)
                } else {
                    setIsOpenViewCustomer(true)
                }
                setCustomerData({
                    ...customerData,
                    companyName: res?.basicDetails?.companyName,
                    displayName: res?.basicDetails?.displayName,
                    phoneNumber: res?.basicDetails?.phone,
                    emailId: res?.basicDetails?.email,
                    location: { value: res?.basicDetails?.location, name: res?.basicDetails?.location },
                    privacyContact: res?.basicDetails?.privacyContact,
                    status: res?.basicDetails?.status,
                    communicationChannel: res?.basicDetails?.communicationChannel,
                    gstTreatment: { value: res?.otherDetails?.GSTTreatment, name: res?.otherDetails?.GSTTreatment },
                    placeOfSupply: { value: res?.otherDetails?.placeOfSupply, name: res?.otherDetails?.placeOfSupply },
                    panNumber: res?.otherDetails?.panNumber,
                    openingBalance: res?.otherDetails?.openingBalance,
                    currency: { name: res?.otherDetails?.currency },
                    taxPreference: res?.otherDetails?.taxPreference,
                    paymentTerms: { value: res?.otherDetails?.paymentTearms, name: res?.otherDetails?.paymentTearms },
                    document: res?.otherDetails?.document,
                    websiteURL: res?.otherDetails?.websiteUrl,
                    twitter: res?.otherDetails?.twitter,
                    skypeNumber: res?.otherDetails?.skypeNameNumber,
                    facebook: res?.otherDetails?.facebook,
                    department: res?.otherDetails?.department,
                    designation: res?.otherDetails?.designation,
                    billingAttention: res?.addressDetail?.billingAddress?.attention,
                    billingAddress: res?.addressDetail?.billingAddress?.address,
                    billingCity: res?.addressDetail?.billingAddress?.city,
                    billingState: res?.addressDetail?.billingAddress?.state,
                    billingPinCode: res?.addressDetail?.billingAddress?.zipCode,
                    billingCountry: res?.addressDetail?.billingAddress?.country,
                    billingPhoneNumber: res?.addressDetail?.billingAddress?.phone,
                    billingFaxNumber: res?.addressDetail?.billingAddress?.faxNumber,
                    sameAsBillingAddress: res?.addressDetail?.sameAsBillingAddress,
                    shippingAttention: res?.addressDetail?.shippingAddress?.attention,
                    shippingAddress: res?.addressDetail?.shippingAddress?.address,
                    shippingCity: res?.addressDetail?.shippingAddress?.city,
                    shippingState: res?.addressDetail?.shippingAddress?.state,
                    shippingPinCode: res?.addressDetail?.shippingAddress?.zipCode,
                    shippingCountry: res?.addressDetail?.shippingAddress?.country,
                    shippingPhoneNumber: res?.addressDetail?.shippingAddress?.phone,
                    shippingFaxNumber: res?.addressDetail?.shippingAddress?.faxNumber,
                    contactPersonSalutation: res?.contactPersonDetail?.salutation,
                    contactPersonFirstName: res?.contactPersonDetail?.firstName,
                    contactPersonLastName: res?.contactPersonDetail?.lastName,
                    contactPersonEmailId: res?.contactPersonDetail?.email,
                    contactPersonPhoneNumber: res?.contactPersonDetail?.phoneNumber,
                    contactPersonPhoneNumberWork: res?.contactPersonDetail?.mobileNumber,
                    remark: res?.remark,
                })
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };
    // ============= Get By Id Inventory Field API =============
    const _deleteCustomer = async (id) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(deleteCustomer(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            setSnackBar("success", response?.payload?.message);
            _getListData();
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Use Effects API =============
    useEffect(() => {
        if (searchValue) {
            _getListData();
        } else {
            _getListData();
        }
    }, [activeTab, page, searchValue])
        useEffect(() => {
        setPage(1);
    }, [searchValue]);
    useEffect(() => {
        setPage(1)
        _getListData(1);
    }, [isApllyFilter])

    useEffect(() => {
        setPage(1)
    }, [activeTab])

    return (
        isOpenAddUpdateCustomer ?
            <AddUpdateCustomer setSearchValue={setSearchValue} setIsOpenAddUpdateCustomer={setIsOpenAddUpdateCustomer} setCustomerData={setCustomerData} customerData={customerData} setSelectedCustomerData={setSelectedCustomerData} selectedCustomerData={selectedCustomerData} _getListData={_getListData} />
            : isOpenAddUpdateInvoice ?
                <AddUpdateInvoice setSearchValue={setSearchValue} setIsOpenAddUpdateInvoice={setIsOpenAddUpdateInvoice} setInvoiceData={setInvoiceData} invoiceData={invoiceData} setPurchaseOrderListData={setPurchaseOrderListData} purchaseOrderListData={purchaseOrderListData} _getListData={_getListData} />
                :
                <Grid container spacing={2} padding={"25px"}>
                    <Grid item xs={12}>
                        <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>
                            Invoice
                        </Typography>
                    </Grid>
                    <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" flexWrap={'wrap'}>
                        <Tabs value={value} onChange={handleChange} className={muiClasses.customTabStyle}>
                            {invoiceCategory.map((ele, index) => (
                                <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                            ))}
                        </Tabs>
                        <Box display="flex" gap={1} flexWrap={'wrap'}>
                            <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={activeTab?.value == 2 ? ["Invoice Number", "Customer Name"] : ["First Name", 'Location', 'Phone Number']} />
                            <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                                <Button className={classes.cancelButton} startIcon={<FilterListIcon />} onClick={() => setIsOpenFilterDrawer(true)} >
                                    Filters
                                </Button>
                            </Badge>
                            {getPermissionList?.editPermission?.includes('Invoice') &&
                                <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => openAddUpdate()}>
                                    {`Create ${activeTab?.value == 1 ? "Customer" : "Invoice"}`}
                                </Button>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        {activeTab?.value == 2 ?
                            <InvoiceTable listData={listData} _getInvoiceById={_getInvoiceById} handleChangePage={handleChangePage} page={page} PerPage={PerPage} />
                            :
                            <CustomerTable _deleteCustomer={_deleteCustomer} listData={listData} _getCustomerById={_getCustomerById} handleChangePage={handleChangePage} page={page} PerPage={PerPage} />

                        }
                    </Grid>
                    <CustomDrawer
                        isDrawerOpen={isOpenViewInvoice}
                        handleClose={() => { setIsOpenViewInvoice(false); setSelectedInvoiceData({}) }}
                        title="View Invoice"
                    >
                        {selectedInvoiceData?.blob &&
                            <iframe
                                allowFullScreen
                                width="100%"
                                style={{ border: "none", flex: 1 }}
                                height={"1000px"}
                                src={`data:text/html;base64,${selectedInvoiceData?.blob}`}
                            />
                        }
                    </CustomDrawer>
                    <CustomDrawer
                        isDrawerOpen={isOpenViewCustomer}
                        handleClose={() => { setIsOpenViewCustomer(false); setSelectedCustomerData({}); setCustomerData({}) }}
                        title="Customer Details"
                    >
                        <ViewCustomer selectedCustomerData={selectedCustomerData} setIsOpenViewCustomer={setIsOpenViewCustomer} />
                    </CustomDrawer>
                    <CustomDrawer
                        isOnlyIconClose
                        isDrawerOpen={isOpenFilterDrawer}
                        handleClose={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}
                        title="Filter"
                    >
                        <Grid container p={2}>
                            {activeTab?.value == 1 &&
                                <>
                                    <Grid item xs={12}>
                                        <Title>Status</Title>
                                    </Grid>
                                    {["Active", "Expired"].map((ele) => {
                                        return (
                                            <Grid item xs={12} sm={6} md={4} key={ele}>
                                                <FormControl component="fieldset">
                                                    <FormGroup>
                                                        <FormControlLabel
                                                            control={<Checkbox checked={filterData.status === ele}
                                                                onChange={() => { setFilterData((prev) => ({ ...prev, status: ele })) }} />}
                                                            sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                            label={ele}
                                                            labelPlacement="end"
                                                        />
                                                    </FormGroup>
                                                </FormControl>
                                            </Grid>
                                        );
                                    })}
                                </>
                            }
                            {activeTab?.value == 2 &&
                                <>
                                    <Grid item xs={12}>
                                        <Title>Invoice Type</Title>
                                    </Grid>
                                    {POTypeOptions.map((ele) => (
                                        <Grid item xs={12} sm={6} md={4} key={ele.id}>
                                            <FormControl component="fieldset">
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={filterData.invoice_type === ele.id.toString()}
                                                                onChange={() => handleinvoice_typeChange(ele.id.toString())}
                                                            />
                                                        }
                                                        sx={{ "& .MuiFormControlLabel-label": { fontSize: "14px", fontFamily: "Satoshi-Medium" } }}
                                                        label={ele.name}
                                                        labelPlacement="end"
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </Grid>
                                    ))}
                                </>
                            }
                            <Grid item xs={12} mt={2} display="flex" justifyContent="end" gap={2}>
                                <Button className={classes.cancelButton}
                                    onClick={() => {
                                        setFilterData(initialFilterState);
                                        //  setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) 
                                    }
                                    }>
                                    Reset Filter
                                </Button>
                                <Button className={classes.saveButton} onClick={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}>
                                    Apply Filter
                                </Button>
                            </Grid>
                        </Grid>
                    </CustomDrawer >
                </Grid >
    );
};

export default Invoice;

const InvoiceTable = ({ listData, _getInvoiceById, handleChangePage, page, PerPage }) => {
    const theme = useTheme();
    const tabelHeader = ["SR.", "Invoice No.", "Date", "Customer Name", "Item", "Quantity", "Total", "Invoice Type", "Action"]

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    return (
        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
            <TableContainer>
                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                    <TableHead>
                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                            {tabelHeader?.map((ele) => {
                                return (
                                    <StyledTableCell>{ele}</StyledTableCell>
                                )
                            })}
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {listData?.response?.length > 0 ?
                            listData?.response?.map((row, index) => (
                                <React.Fragment key={index}>
                                    <StyledTableRow>
                                        <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                        <StyledTableCell>{row?.invoiceNumber || "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.invoiceDate ? standardDateFormat(row?.invoiceDate) : "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.customer_name || "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.itemType || "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.totalQuantity || "NA"}</StyledTableCell>
                                        <StyledTableCell>{Number(row?.totalAmount).toFixed(3) || "NA"}</StyledTableCell>
                                        <StyledTableCell>
                                            {row?.invoice_type &&
                                                <StatusButton text={row?.invoice_type == 1 ? "Local" : "Import"} color={row?.invoice_type == "1" ? "primary" : "success"} />
                                            }
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            {getPermissionList?.viewPermission?.includes('Invoice') &&
                                                <Box display={"flex"} gap={1}>
                                                    <IconBackground icon={"visibility"} onClick={() => _getInvoiceById(row?._id)} />
                                                </Box>
                                            }
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </React.Fragment>
                            ))
                            :
                            <StyledTableRow>
                                <StyledTableCell colSpan={12}>
                                    <NoDataFound />
                                </StyledTableCell>
                            </StyledTableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <CommonPagination
                totalCount={listData?.count}
                count={Math.ceil(listData?.count / PerPage)}
                itemsPerPage={PerPage}
                page={page}
                onChange={handleChangePage}
            />
        </Box>
    )
}

const CustomerTable = ({ listData, _getCustomerById, handleChangePage, page, PerPage, _deleteCustomer }) => {
    const theme = useTheme();
    const confirmDialogue = useConfirm();
    const tabelHeader = ["SR.", "Company Name", "PAN NUmber", "Location", "Phone", "Status", "Action"]
    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    return (
        <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
            <TableContainer>
                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                    <TableHead>
                        <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                            {tabelHeader?.map((ele) => {
                                return (
                                    <StyledTableCell>{ele}</StyledTableCell>
                                )
                            })}
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {listData?.response?.length > 0 ?
                            listData?.response?.map((row, index) => (
                                <React.Fragment key={index}>
                                    <StyledTableRow>
                                        <StyledTableCell>{index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                        <StyledTableCell>{row?.basicDetails?.companyName || "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.otherDetails?.panNumber || "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.basicDetails?.location || "NA"}</StyledTableCell>
                                        <StyledTableCell>{row?.basicDetails?.phone || "NA"}</StyledTableCell>
                                        <StyledTableCell>
                                            {row?.basicDetails?.status &&
                                                <StatusButton text={row?.basicDetails?.status || "NA"} color={row?.basicDetails?.status == "Active" ? "success" : "gray"} />
                                            }
                                        </StyledTableCell>
                                        <StyledTableCell>
                                            <Box display={"flex"} gap={1}>
                                                {getPermissionList?.viewPermission?.includes('Invoice') &&
                                                    <IconBackground icon={"visibility"} onClick={() => _getCustomerById(row?._id, false)} />
                                                }
                                                {getPermissionList?.editPermission?.includes('Invoice') &&
                                                    <IconBackground icon={"edit"} onClick={() => _getCustomerById(row?._id, true)} />
                                                }
                                                {getPermissionList?.editPermission?.includes('Invoice') &&
                                                    <IconBackground icon={"delete"}
                                                        onClick={(e) => {
                                                            confirmDialogue({
                                                                title: `Are you sure you want to delete?`,
                                                            }).then(() => {
                                                                _deleteCustomer(row?._id)
                                                            }).catch((err) => { console.error(err) });
                                                        }} />
                                                }
                                            </Box>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </React.Fragment>
                            ))
                            :
                            <StyledTableRow>
                                <StyledTableCell colSpan={12}>
                                    <NoDataFound />
                                </StyledTableCell>
                            </StyledTableRow>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <CommonPagination
                totalCount={listData?.count}
                count={Math.ceil(listData?.count / PerPage)}
                itemsPerPage={PerPage}
                page={page}
                onChange={handleChangePage}
            />
        </Box>
    )
}
